import { TbPhotoPlus } from "react-icons/tb";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Ripple, initTE } from "tw-elements";
import Swal from "sweetalert2";
// import axios from "axios";
import axios from "../../../context/axios";
import { AuthContext } from "../../../context/authContext";
import imageCompression from "browser-image-compression";

const AddTourPackage = () => {
  useEffect(() => {
    initTE({ Ripple });
  }, []);
  const navigate = useNavigate();

  //store database states
  const [file, setFile] = useState("");
  // const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState(0);
  const [groupCount, setGroupCount] = useState(0);
  const [languages, setLanguages] = useState("");
  const [duration, setDuration] = useState("");
  const [cities, setCities] = useState("");
  const [description, setDesc] = useState("");
  const [introduction, setIntroduction] = useState("");
  const [placeImages, setPlaceImages] = useState([]);
  const { user } = useContext(AuthContext);
  const [subCategoryFiles, setSubCategoryFiles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [mainCity, setMainCity] = useState("");
  const [providedServices, setProvidedServices] = useState([]);
  const [dayDescriptions, setDayDescriptions] = useState({});
  const [originalPrice, setOriginalPrice] = useState(0);
  const [trainOriginalPrice, setTrainOriginalPrice] = useState(0);
  const [trainPrice, setTrainPrice] = useState(0);
  const [transportMode, setTransportMode] = useState("flight"); // default is flight
  const [availableMonth, setAvailableMonth] = useState("");
  const [includeTrain, setIncludeTrain] = useState(false);

  const [title, setTitle] = useState("");
  const [region, setRegion] = useState("");
  const [countries, setCountries] = useState([]);

  const [subCategory, setSubCategory] = useState("");
  const [inclusionInputs, setInclusionInputs] = useState([""]);
  const [exclusionInputs, setExclusionInputs] = useState([""]);
  // Handler for file input change (multiple files)
  const handleSubCategoryFilesChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setSubCategoryFiles((prev) => [...prev, ...selectedFiles]);
    setPlaceImages((prev) => [...prev, ...selectedFiles]);
  };

  const getNextFiveMonths = () => {
    const months = [];
    const today = new Date();
    for (let i = 0; i < 5; i++) {
      const nextMonth = new Date(today.getFullYear(), today.getMonth() + i, 1);
      const label = nextMonth.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });
      months.push(label);
    }
    return months;
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get("/getcoutryregion");
        setCountries(response.data);
      } catch (err) {
        console.error("Failed to fetch countries", err);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    initTE({ Ripple });

    // Fetch categories and states
    const fetchData = async () => {
      try {
        const [catRes, stateRes] = await Promise.all([
          axios.get("/categories"),
          axios.get("/states"),
        ]);

        setCategories(catRes.data);
        setStates(stateRes.data);
      } catch (error) {
        console.error("Failed to fetch categories or states:", error);
      }
    };

    fetchData();
  }, []);

  const currentUser = user.email;
  console.log(file);
  //send data to database
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !file ||
      !title ||
      !category ||
      !price ||
      !groupCount ||
      !languages ||
      !duration ||
      !cities ||
      !description ||
      !introduction
    ) {
      Swal.fire({
        title: "Uploading...",
        text: "Please wait while we save the tour package.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      return;
    }

    try {
      const result = await Swal.fire({
        title: "Confirm to save details for review",
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: `Cancel`,
      });

      if (!result.isConfirmed) {
        Swal.fire("Tour adding Cancelled!", "", "error");
        return;
      }

      // Prepare FormData with files and other fields
      const formData = new FormData();
      formData.append("file", file); // single cover photo
      subCategoryFiles.forEach((f, i) =>
        formData.append("subCategoryFiles", f)
      ); // multiple images

      // Append other data fields
      formData.append("currentUser", currentUser);
      formData.append("title", title);
      formData.append("category", category);
      formData.append("price", price);
      formData.append("groupCount", groupCount);
      formData.append("languages", languages);
      // formData.append("duration", duration);
      formData.append("cities", cities);

      formData.append("introduction", introduction);

      formData.append("state", selectedState);
      formData.append("mainCity", mainCity);
      formData.append("providedServices", JSON.stringify(providedServices));
      formData.append("description", description);
      formData.append("dayDescriptions", JSON.stringify(dayDescriptions));
      // if (category === "683ab025cad89abf5b529d66") {
      //   formData.append("originalPrice", originalPrice);
      // }
      formData.append("availableMonth", availableMonth);
      formData.append("duration", JSON.stringify(duration));
      formData.append("transportMode", transportMode);

      if (includeTrain) {
        formData.append("trainOriginalPrice", trainOriginalPrice);
        formData.append("trainPrice", trainPrice);
      }
      formData.append("originalPrice", originalPrice);
      formData.append("title", title);
      formData.append("region", region);
      formData.append("subCategory", subCategory);
      const inclusionsObj = {};
      inclusionInputs.forEach((item, index) => {
        if (item.trim()) inclusionsObj[`inclusion${index + 1}`] = item.trim();
      });
      const exclusionsObj = {};
      exclusionInputs.forEach((item, index) => {
        if (item.trim()) exclusionsObj[`exclusion${index + 1}`] = item.trim();
      });

      formData.append("Inclusions", JSON.stringify(inclusionsObj));
      formData.append("Exclusions", JSON.stringify(exclusionsObj));
      // Send formData to backend
      const response = await axios.post("/tours", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      Swal.fire(response.data.message, "", "success");
      navigate("/admin/addtour");
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Upload Error",
        text: err.message || "Something went wrong!",
      });
    }
  };

  //gather all form data

  return (
    <div className="mx-auto max-w-2xl px-4 py-10 sm:px-4 sm:py-15 lg:max-w-7xl lg:px-8">
      <form>
        <div className="space-y-12">
          {/* basic details */}
          <div>
            <h2 className="text-3xl font-semibold leading-7 text-[#41A4FF] text-center">
              Add Tour Package
            </h2>
            <p className="mt-3 text-red-500 text-lg leading-6 text-center">
              This information will be displayed publicly so be careful what you
              share.
            </p>

            {/* <div className="max-w-md mx-auto mt-12 p-6  rounded-lg ">
              <label
                htmlFor="photo"
                className="block text-xl font-semibold text-gray-900 mb-6 text-center"
              >
                Add a cover photo for the package
              </label>

              <div className="flex justify-center mb-8">
                <img
                  className="w-32 h-32 rounded-3xl object-cover shadow-lg border border-gray-200"
                  src={
                    file
                      ? URL.createObjectURL(file)
                      : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                  }
                  alt="cover preview"
                />
              </div>

              <div className="flex justify-center">
                <label
                  htmlFor="photo"
                  className="cursor-pointer flex flex-col items-center text-gray-500 hover:text-blue-600 transition-colors"
                  title="Click to add or change cover photo"
                >
                  <TbPhotoPlus className="h-12 w-12 mb-2" aria-hidden="true" />
                  <span className="text-sm font-medium">
                    Click here to add a Cover Photo
                  </span>
                  <input
                    id="photo"
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={async (e) => {
                      const image = e.target.files[0];
                      if (!image) return;

                      if (image.size > 10 * 1024 * 1024) {
                        Swal.fire({
                          icon: "info",
                          title: "Compressing image...",
                          text: "Your selected image is over 10MB. Compressing before upload.",
                        });
                      }

                      try {
                        const options = {
                          maxSizeMB: 1, // target size under 1MB
                          maxWidthOrHeight: 1920,
                          useWebWorker: true,
                        };

                        const compressedFile = await imageCompression(
                          image,
                          options
                        );

                        if (compressedFile.size > 10 * 1024 * 1024) {
                          Swal.fire({
                            icon: "error",
                            title: "Image Too Large",
                            text: "Even after compression, the image is too large. Please select a smaller image.",
                          });
                          return;
                        }

                        setFile(compressedFile);
                      } catch (error) {
                        console.error("Image compression error:", error);
                        Swal.fire("Compression Error", error.message, "error");
                      }
                    }}
                  />
                </label>
              </div>
            </div>
             */}
            <div className="max-w-3xl mx-auto mt-12 bg-white p-8 rounded-2xl shadow-xl">
              <h3 className="text-2xl font-bold text-center text-blue-700 mb-6">
                Upload Cover Photo
              </h3>

              <div className="flex flex-col items-center space-y-6">
                {/* Preview */}
                <div className="relative group">
                  <img
                    className="w-40 h-40 object-cover rounded-2xl border-2 border-gray-300 shadow-md transition-all duration-300 group-hover:blur-sm"
                    src={
                      file
                        ? URL.createObjectURL(file)
                        : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                    }
                    alt="Cover Preview"
                  />
                  <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black bg-opacity-50 rounded-2xl">
                    <TbPhotoPlus className="text-white text-4xl mb-2" />
                    <span className="text-white text-sm font-semibold">
                      Change Photo
                    </span>
                  </div>
                </div>

                {/* Upload Input */}
                <label
                  htmlFor="photo"
                  className="cursor-pointer px-5 py-3 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition"
                >
                  Upload Photo
                  <input
                    id="photo"
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={async (e) => {
                      const image = e.target.files[0];
                      if (!image) return;

                      if (image.size > 10 * 1024 * 1024) {
                        Swal.fire({
                          icon: "info",
                          title: "Compressing image...",
                          text: "Your selected image is over 10MB. Compressing before upload.",
                        });
                      }

                      try {
                        const options = {
                          maxSizeMB: 1,
                          maxWidthOrHeight: 1920,
                          useWebWorker: true,
                        };

                        const compressedFile = await imageCompression(
                          image,
                          options
                        );

                        if (compressedFile.size > 10 * 1024 * 1024) {
                          Swal.fire({
                            icon: "error",
                            title: "Image Too Large",
                            text: "Even after compression, the image is too large. Please select a smaller image.",
                          });
                          return;
                        }

                        setFile(compressedFile);
                      } catch (error) {
                        console.error("Image compression error:", error);
                        Swal.fire("Compression Error", error.message, "error");
                      }
                    }}
                  />
                </label>

                <p className="text-sm text-gray-500">
                  Only JPG, PNG under 10MB. Automatically compressed if too
                  large.
                </p>
              </div>
            </div>
            {/* name and category */}
            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              {/* add name */}
              <div className="sm:col-span-3">
                <label
                  htmlFor="title"
                  className="block text-lg font-medium leading-6 text-gray-900"
                >
                  Add Name for Package
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    name="title"
                    id="title"
                    placeholder="Type Here"
                    className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                  />
                </div>
              </div>
              {/* select category */}
              <div className="sm:col-span-3">
                <label
                  htmlFor="category"
                  className="block text-lg font-medium leading-6 text-gray-900"
                >
                  Select Tour Category
                </label>
                <div className="mt-2">
                  <select
                    id="category"
                    name="category"
                    className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(e) => setCategory(e.target.value)}
                  >
                    <option value="">-- Select Category --</option>
                    {categories.map((cat) => (
                      <option key={cat._id} value={cat._id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="sm:col-span-3">
                <label
                  htmlFor="region"
                  className="block text-lg font-medium leading-6 text-gray-900"
                >
                  Select Region
                </label>
                <div className="mt-2">
                  <select
                    id="region"
                    name="region"
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                    className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  >
                    <option value="">-- Select Country --</option>
                    {countries.map((country) => (
                      <option key={country._id} value={country._id}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="sm:col-span-3">
                <label
                  htmlFor="subCategory"
                  className="block text-lg font-medium leading-6 text-gray-900"
                >
                  Select Subcategory Tag
                </label>
                <div className="mt-2">
                  <select
                    id="subCategory"
                    name="subCategory"
                    value={subCategory}
                    onChange={(e) => setSubCategory(e.target.value)}
                    className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  >
                    <option value="">-- Select Subcategory --</option>
                    <option value="LIMITED DEAL">LIMITED DEAL</option>
                    <option value="SPECIAL OFFER">SPECIAL OFFER</option>
                    <option value="POPULAR">POPULAR</option>
                    <option value="LAST MINUTE">LAST MINUTE</option>
                    <option value="HOT DEAL">HOT DEAL</option>
                    <option value="BEST SELLER">BEST SELLER</option>
                  </select>
                </div>
              </div>

          

              {/* add original price */}
              <div className="sm:col-span-3">
                <label
                  htmlFor="originalPrice"
                  className="block text-lg font-medium leading-6 text-gray-900"
                >
                  Add Original Price (Before Discount)
                </label>
                <div className="mt-2">
                  <input
                    type="number"
                    name="originalPrice"
                    id="originalPrice"
                    placeholder="Original Price"
                    className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(e) => setOriginalPrice(e.target.value)}
                  />
                </div>
              </div>

              {/* add price*/}
              <div className="sm:col-span-3">
                <label
                  htmlFor="price"
                  className="block text-lg font-medium leading-6 text-gray-900"
                >
                  Add PerPerson Price for Package
                </label>
                <div className="mt-2">
                  <input
                    type="number"
                    name="price"
                    id="price"
                    placeholder="Discounted Price"
                    className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    checked={includeTrain}
                    onChange={(e) => setIncludeTrain(e.target.checked)}
                    className="mr-2"
                  />
                  Include Train Pricing
                </label>
              </div>

              {includeTrain && (
                <>
                  <div className="mb-4">
                    <label className="block text-md font-semibold text-gray-700 mb-1">
                      Train Original Price
                    </label>
                    <input
                      type="number"
                      value={trainOriginalPrice}
                      onChange={(e) =>
                        setTrainOriginalPrice(Number(e.target.value))
                      }
                      className="block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-md font-semibold text-gray-700 mb-1">
                      Train Price
                    </label>
                    <input
                      type="number"
                      value={trainPrice}
                      onChange={(e) => setTrainPrice(Number(e.target.value))}
                      className="block w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                    />
                  </div>
                </>
              )}

              {/* select group size */}
              <div className="sm:col-span-3">
                <label
                  htmlFor="maxsize"
                  className="block text-lg font-medium leading-6 text-gray-900"
                >
                  Add Maximum Group Size
                </label>
                <div className="mt-2">
                  <input
                    type="number"
                    id="maxsize"
                    name="maxsize"
                    className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(e) => {
                      setGroupCount(e.target.value);
                    }}
                  />
                </div>
              </div>

              {/* Main City Input */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Main City
                </label>
                <input
                  type="text"
                  value={mainCity}
                  onChange={(e) => setMainCity(e.target.value)}
                  className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm"
                />
              </div>

              {/* Provided Services Checkboxes */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Provided Services
                </label>
                {[
                  "Flight",
                  "Transportation",
                  "Mess",
                  "Living",
                  "Guide",
                  "Tickets",
                ].map((service) => (
                  <div key={service} className="flex items-center mb-1">
                    <input
                      type="checkbox"
                      value={service}
                      checked={providedServices.includes(service)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setProvidedServices((prev) => [...prev, service]);
                        } else {
                          setProvidedServices((prev) =>
                            prev.filter((s) => s !== service)
                          );
                        }
                      }}
                      className="mr-2"
                    />
                    <span>{service}</span>
                  </div>
                ))}
              </div>
              {/* languages and duration */}

              {/* add languages */}
              <div className="sm:col-span-3">
                <label
                  htmlFor="languages"
                  className="block text-lg font-medium leading-6 text-gray-900"
                >
                  Add Languages
                </label>
                <p className="text-sm">(English, French, German etc..)</p>
                <div className="mt-2">
                  <input
                    type="text"
                    name="languages"
                    id="languages"
                    placeholder="Type Here"
                    className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(e) => {
                      setLanguages(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-md font-semibold text-gray-700 mb-1">
                  Select Available Months
                </label>
                <div className="grid grid-cols-2 gap-2">
                  {getNextFiveMonths().map((month, index) => (
                    <label key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        value={month}
                        checked={availableMonth.includes(month)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setAvailableMonth([...availableMonth, month]);
                          } else {
                            setAvailableMonth(
                              availableMonth.filter((m) => m !== month)
                            );
                          }
                        }}
                      />
                      <span>{month}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* select duration */}
              <div className="col-span-full flex flex-col gap-6">
              <label
                  htmlFor="duration"
                  className="block text-lg font-medium leading-6 text-gray-900"
                >
                  Select Tour Duration
                </label>
                <p className="text-sm">(In days)</p>
                <div className="mt-2">
                  <select
                    id="duration"
                    name="duration"
                    className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(e) => {
                      const days = Number(e.target.value);
                      setDuration({ day: days, night: days - 1 }); // Store in day/night format

                      const newDescriptions = {};
                      for (let i = 1; i <= days; i++) {
                        newDescriptions[`day${i}`] = {
                          title: `Day ${i} - `,
                          description: "",
                          images: [],
                        };
                      }
                      setDayDescriptions(newDescriptions);
                    }}
                  >
                    <option>--Select One--</option>
                    <option value={1}>1 Day</option>
                    <option value={2}>2 Days</option>
                    <option value={3}>3 Days</option>
                    <option value={5}>5 Days</option>
                    <option value={7}>7 Days</option>
                    <option value={9}>9 Days</option>
                    <option value={12}>12 Days</option>
                    <option value={15}>15 Days</option>
                  </select>
                </div>
              </div>

              {duration?.day > 0 && (
  <div className="col-span-full w-full mt-6">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">
                    Day-wise Travel Description
                  </h3>
                  {Array.from({ length: duration?.day || 0 }, (_, i) => (
                    <div
                      key={i}
                      className="mb-6 border p-4 rounded-lg shadow-sm bg-gray-50"
                    >
                      <label className="block text-md font-semibold text-gray-700 mb-1">
                        Day {i + 1} Title
                      </label>
                      <input
                        type="text"
                        className="block w-full rounded-md border-gray-300 shadow-sm mb-2 sm:text-sm"
                        value={dayDescriptions[`day${i + 1}`]?.title || ""}
                        onChange={(e) =>
                          setDayDescriptions((prev) => ({
                            ...prev,
                            [`day${i + 1}`]: {
                              ...prev[`day${i + 1}`],
                              title: e.target.value,
                            },
                          }))
                        }
                        placeholder={`Enter title for Day ${i + 1}`}
                      />

                      <label className="block text-md font-semibold text-gray-700 mb-1">
                        Description
                      </label>
                      <textarea
                        rows={3}
                        className="block w-full rounded-md border-gray-300 shadow-sm mb-2 sm:text-sm"
                        value={
                          dayDescriptions[`day${i + 1}`]?.description || ""
                        }
                        onChange={(e) =>
                          setDayDescriptions((prev) => ({
                            ...prev,
                            [`day${i + 1}`]: {
                              ...prev[`day${i + 1}`],
                              description: e.target.value,
                            },
                          }))
                        }
                        placeholder={`What will you do on Day ${i + 1}?`}
                      />

                      <label className="block text-md font-semibold text-gray-700 mb-1">
                        Upload Images
                      </label>
                      <input
                        type="file"
                        multiple
                        onChange={async (e) => {
                          const selectedFiles = Array.from(e.target.files);
                          const compressedPreviews = [];

                          for (const file of selectedFiles) {
                            try {
                              const compressed = await imageCompression(file, {
                                maxSizeMB: 1,
                                maxWidthOrHeight: 1920,
                                useWebWorker: true,
                              });

                              // Preview using compressed blob
                              const previewUrl =
                                URL.createObjectURL(compressed);
                              compressedPreviews.push(previewUrl);

                              // Optionally: store the actual compressed file somewhere if needed for upload
                              // (e.g., in a separate "compressedFiles" state)
                            } catch (error) {
                              console.error("Compression error:", error);
                            }
                          }

                          setDayDescriptions((prev) => ({
                            ...prev,
                            [`day${i + 1}`]: {
                              ...prev[`day${i + 1}`],
                              images: [
                                ...(prev[`day${i + 1}`]?.images || []),
                                ...compressedPreviews,
                              ],
                            },
                          }));
                        }}
                        className="block w-full text-sm text-gray-600"
                      />

                      {dayDescriptions[`day${i + 1}`]?.images?.length > 0 && (
                        <div className="flex flex-wrap mt-2 gap-2">
                          {dayDescriptions[`day${i + 1}`].images.map(
                            (img, idx) => (
                              <img
                                key={idx}
                                src={img}
                                alt={`Day ${i + 1} img ${idx + 1}`}
                                className="w-24 h-24 object-cover rounded-md"
                              />
                            )
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
<div className="col-span-full w-full">
<label
                  htmlFor="placeImages"
                  className="block text-lg font-medium leading-6 text-gray-900 mt-10"
                >
                  Upload Tour Place Images (Multiple)
                </label>
                <div className="mt-6 flex flex-row gap-4">
                  {placeImages.length > 0 ? (
                    placeImages.map((img) => (
                      <img
                        key={`${img.name}-${img.lastModified}`}
                        src={URL.createObjectURL(img)}
                        alt={`tour place`}
                        className="w-40 h-40 rounded-lg object-cover"
                      />
                    ))
                  ) : (
                    <p className="text-gray-400">No images selected yet.</p>
                  )}
                </div>
                <div className="mt-4">
                  <label
                    htmlFor="placeImagesInput"
                    className="inline-block cursor-pointer px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                  >
                    Select Images
                  </label>
                  <input
                    type="file"
                    id="placeImagesInput"
                    multiple
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleSubCategoryFilesChange}
                  />
                </div>
              </div>

              {/* add cities */}
              <div className="col-span-full">
                <label
                  htmlFor="places"
                  className="block text-lg font-medium leading-6 text-gray-900"
                >
                  Cities That included in your package
                </label>
                <p className="text-sm">
                  (Type cities in visiting order (if you are starting in colombo
                  and then you wish to travel to galle type colombo, Galle))
                </p>
                <div className="mt-2">
                  <input
                    type="text"
                    name="places"
                    id="places"
                    className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="Type Here"
                    onChange={(e) => {
                      setCities(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-900 mb-2">
              Inclusions
            </label>
            {inclusionInputs.map((value, index) => (
              <div key={index} className="flex items-center gap-2 mb-2">
                <input
                  type="text"
                  value={value}
                  onChange={(e) => {
                    const newInputs = [...inclusionInputs];
                    newInputs[index] = e.target.value;
                    setInclusionInputs(newInputs);
                  }}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
                  placeholder={`Inclusion ${index + 1}`}
                />
                {index === inclusionInputs.length - 1 && (
                  <button
                    type="button"
                    onClick={() => setInclusionInputs([...inclusionInputs, ""])}
                    className="text-green-600 text-2xl"
                  >
                    +
                  </button>
                )}
              </div>
            ))}
          </div>

          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-900 mb-2">
              Exclusions
            </label>
            {exclusionInputs.map((value, index) => (
              <div key={index} className="flex items-center gap-2 mb-2">
                <input
                  type="text"
                  value={value}
                  onChange={(e) => {
                    const newInputs = [...exclusionInputs];
                    newInputs[index] = e.target.value;
                    setExclusionInputs(newInputs);
                  }}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
                  placeholder={`Exclusion ${index + 1}`}
                />
                {index === exclusionInputs.length - 1 && (
                  <button
                    type="button"
                    onClick={() => setExclusionInputs([...exclusionInputs, ""])}
                    className="text-green-600 text-2xl"
                  >
                    +
                  </button>
                )}
              </div>
            ))}
          </div>
          {/* add description */}
          <div className="col-span-full">
            <label
              htmlFor="description"
              className="block text-lg font-medium leading-6 text-gray-900"
            >
              Add a brief description about your tour package
            </label>
            <p className="text-sm">
              (This part will show as overall description part of tourdetails)
            </p>
            <div className="mt-2">
              <textarea
                rows={10}
                type="text"
                name="description"
                id="description"
                className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                placeholder="Type Your Description Here"
                onChange={(e) => {
                  setDesc(e.target.value);
                }}
              />
            </div>
          </div>

          {/* add Introduction */}
          <div className="col-span-full">
            <label
              htmlFor="intro"
              className="block text-lg font-medium leading-6 text-gray-900"
            >
              Add a Introduction about your tour destinations and activites
            </label>
            <p className="text-sm">
              (This part will show as overall introduction part of tour)
            </p>
            <div className="mt-2">
              <textarea
                rows={10}
                type="text"
                name="intro"
                id="intro"
                className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                placeholder="Type Your Introduction Here"
                onChange={(e) => {
                  setIntroduction(e.target.value);
                }}
              />
            </div>
          </div>
        </div>

        {/* reset submit button */}
        <div className="mt-6 flex items-center justify-end gap-x-6">
          <button
            type="reset"
            className="text-lg font-semibold leading-6  text-red-700"
            value={"Reset"}
          >
            Reset
          </button>
          <button
            type="submit"
            className="rounded-md bg-black px-3 py-2 text-lg font-semibold text-white shadow-sm hover:bg-[#41A4FF] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={handleSubmit}
          >
            Submit For Review
          </button>
        </div>
      </form>
    </div>
  );
};
export default AddTourPackage;






